import { Link } from 'gatsby';
import _, { isEmpty, map } from 'lodash';
import React from 'react';
import { motion } from 'framer-motion';
import { LazyLoadImage } from 'react-lazy-load-image-component';

export default function FreeZonePartnershipBenefits({ id, data }) {
  const htmlTitle = _.get(data, 'htmlTitle', '');
  const bgImage = _.get(data, 'bgImage', {});
  const bgImageMobile = _.get(data, 'bgImageMobile', {});
  const items = _.get(data, 'items', []);
  const isBecomePartner =
  typeof window !== 'undefined' && _.includes(window.location.pathname, 'become-a-partner');

  return (
    <section
      id={id}
      className="bg-[#CE445B] pb-[60px] pt-[50px] md:py-[100px] overflow-hidden lg:pb-[71px] relative
      ">
      <div
        className={`px-4 mx-auto relative flex flex-col gap-y-12 md:gap-y-10
        lg:gap-y-20 z-10 ${isBecomePartner?'max-w-[1169px]':'max-w-[1752px]'}`}>
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: 0.4 }}
          viewport={{ once: true }}
          className="flex flex-col gap-y-5">
          <div
            dangerouslySetInnerHTML={{ __html: htmlTitle }}
            className="text-clamp20to40  h2-child:text-clamp20to40 text-white h2-child:leading-1.25
            h2-child:md:leading-[125%]  text-center
            h2-child:!m-0"
          />
          <div className="h-[2px] w-[50px] md:w-[70px] bg-white mx-auto" />
        </motion.div>
        {isEmpty(items) || (
          <div
            className={`grid gap-x-4 md:gap-x-10 gap-y-[36px] grid-cols-1 lg:grid-cols-3
            md:gap-y-[50px] md:justify-center`}>
            {map(items, (item, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.1 * (index + 1), delay: 0.6 }}
                className="flex flex-col gap-y-2 md:gap-y-5">
                {isEmpty(item.content.image) || (
                  <div
                    className="w-[67px] lg:w-[70px] xl:w-[90px]
                  h-auto mx-auto flex">
                    <LazyLoadImage
                      src={item.content.image.url}
                      width="100%"
                      effect="blur"
                      placeholderSrc={`${item.content.image}`}
                      className="w-full h-full object-cover"
                    />
                  </div>
                )}
                <div
                  dangerouslySetInnerHTML={{ __html: item.content.htmlText }}
                  className="p-child:text-[#e5e5e5] p-child:text-clamp14to16 p-child:font-normal
                    p-child:leading-[1.4] p-child:mb-0 p-child:ltr:font-URWDINRegular p-child:rtl:font-GESSTwoDWTCLight text-center
                    flex flex-col items-center gap-1 max-w-[80%] lg:max-w-full mx-auto
                    first:p-child:!text-[16px]"
                />
              </motion.div>
            ))}
          </div>
        )}
      </div>
      {isEmpty(bgImage) || (
        <img
          src={bgImage.url}
          alt="Benefits"
          className="absolute hidden md:block inset-0 object-cover h-full w-full bg-blend-multiply opacity-10"
        />
      )}
      {!isEmpty(bgImageMobile) ? (
        <img
          src={bgImageMobile?.url}
          alt="Benefits"
          className="absolute inset-0 object-cover h-full w-full bg-blend-multiply opacity-10"
        />
      ) : (
        isEmpty(bgImage) || (
          <img
            src={bgImage.url}
            alt="Benefits"
            className="absolute inset-0 object-cover h-full w-full bg-blend-multiply opacity-10"
          />
        )
      )}
    </section>
  );
}

